<template>
  <div id="videoCir">

    <div class="logo-cir">
      <div class="navbar-brand" @click="goToHomePage">
            <span class="cir-logo-container">
              <img :src="getLogo" class="logo" alt="Logo" />
            </span>
        </div>
    </div>

    <div class="content_iframe">
    <div class="fluidMedia">
      <iframe
        id="iframeVideoCir"
        :src="currentVideo.cryptedURL"
        class="iframe-video"
        frameborder="0"
        width="100%"
        allow="autoplay"
        allowFullScreen
        height="100%"
      ></iframe>
    </div>
    </div>




    <div id="custom-footer-page" class="custom-footer-page">
      <div class="copy">
        <b class="currentYear"> © {{ clientName }} {{ currentYear }}</b>
        <p class="p a_footer">
          {{ $t('labels.powered_by') }}
          <a href="https://www.empreinte.com/" target="_blank " class="a_footer">empreinte.com</a>
        </p>

      </div>

    </div>




  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Mixin from '@/mixins/Mixin';

export default {
  name: 'VideoCir',
  metaInfo: {
    title: process.env.META_TITLA,
  },
  components: {

  },
   mixins: [Mixin],
  computed: {
    ...mapGetters({
      currentLogo: 'layout/getCurrentLogo',

        playerUrl: 'videos/getPlayerUrl',
        playerSkin: 'layout/getCurrentSkinPlayer',
        currentVideo: 'videos/getCurrentVideo',

    }),
    getLogo() {
      return this.currentLogo ? this.currentLogo : './static/logo.png';
    },
    currentYear() {
      return new Date().getFullYear();
    },
    clientName() {
      return process.env.CLIENT_NAME;
    },

  },

  methods: {
    ...mapActions('videos', ['paginateVideos','getCryptedUrl','setCurrentVideo']),

  },

  data() {
    return {};
  },
  async mounted(){
    const pathname = this.$route.name;
    console.log("pathname",pathname)
    if (pathname === 'videocir') {
      let id=this.$route.params.videoId;
      await this.getCryptedUrl({v:parseInt(id)});
      let current = this.playerUrl;
      current.cryptext=current.crypted;
      //current.skin = this.playerSkin;
      current.id=parseInt(id);

      await this.setCurrentVideo(current);

      console.log("setCurrentVideo ",current)
    }
  }
  ,
};
</script>

<style  lang="scss">

  #videoCir{
    height: 100vh;
    overflow: hidden;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    .logo-cir{
      display: flex;
      justify-content: center;
      padding: 0.5em 0;
    }
    .logo{
        cursor: pointer;
    }

    .currentYear{
      margin-right: 0.5em;
    }
    .a_footer ,.currentYear{
      color:#ffffff ;
    }
    .a_footer:hover{
      color:#ffffff !important ;
      text-decoration:none!important;
    }
    .item-footer{
      cursor: pointer;
    }
    .p{
      margin-bottom: 0rem;
    }
    .copy{
      display: flex;
      align-items: center;
    }
    .custom-footer-page{
      z-index: 99;
      align-items: center;
      padding: 0 3em;
      height: 58px;
      background-color: var(--primary-color);
      display: flex;
      justify-content: center;
      width: 100%;
    right: 0;
    left: 0;
      padding: 0 -15px;
    }
  }

#app{
  background-color:white!important;
}

  .fluidMedia {
    position: relative;
    padding-bottom: 56.25%; /* proportion value to aspect ratio 16:9 (9 / 16 = 0.5625 or 56.25%) */
    height: 0;
    overflow: hidden;
    justify-content: center;
    display: flex;
  }

  .fluidMedia iframe {

    position: absolute;
    top: 0;
    margin: auto;
    width: 100%;
    height: 100%;
  }
.content_iframe{
  flex-grow: 1;

  width: 75%;
  margin: auto;
}
  .content
  {padding: 0!important;

  }
</style>



// WEBPACK FOOTER //
// src/components/VideoCir.vue